import { getUser } from "@/utils/user.utils";

export default {
    notifications: [],
    inGame: {
        totalOnline: 0,
        totalOffline: 0,
    },
    user: getUser() || {
        game_account: {}
    },
    userRole: {
        isAdmin: false,
        isDeveloper: false,
        isModerator: false,
    },
    userRestrictions: {
        has_disabled_paypal: 0,
        has_disabled_stripe: 0,
        has_reached_paypal_qualified_amount: false
    },
    config: {
        payments: {
            cost: [],
            statuses: [],
            recommended: 0,
            multiplePointsBy: 0,
            currency: '',
            minimumToUsePayPal: 0,
        },
        stripe: {
            sku: '',
            PK: ''
        },
        paypal: {},
        referred: {},
        gameLauncher: {},
    },
    componentVisibility: {
        menu: true
    },
    lastNotificationId: 0,
}
